<template>
  <b-form v-if="user">
    <h3 class="mt-4 mb-3">
      <b>Login Information</b>
    </h3>

    <b-row>
      <b-col>
        <b-alert
          :show="!user.email_verified"
          variant="warning"
          class="verify-alert"
        >
          <p><b>Your email address hasn't been verified!</b></p>
          <p>
            Click
            <router-link
              :to="{ name: 'auth.verify-page', params: { account: 'email' } }"
              >here</router-link
            >
            to verify your account
          </p>
        </b-alert>
      </b-col>
    </b-row>

    <b-row :class="isMobile ? 'd-block' : ''">
      <b-col>
        <b-form-group id="input-group-email" class="col-12">
          <div class="input-link" @click="change('email')">
            <b-link class="buttontext">Change</b-link>
          </div>
          <b-form-input
            id="input-email"
            type="email"
            disabled
            v-model="user.email"
            class="input-effect"
            :class="user.email ? 'has-content' : ''"
          ></b-form-input>
          <label>Email address</label>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group id="input-group-password" class="col-12">
          <div class="input-link" @click="change('password')">
            <b-link class="buttontext">Change</b-link>
          </div>
          <b-form-input
            id="input-password"
            type="password"
            disabled
            value="••••••••••••••••"
            class="input-effect has-content"
          ></b-form-input>
          <label>Password</label>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    change(field) {
      this.$router.push({
        name: 'user.verify-page',
        params: { field: field }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f9fa;
}
.buttontext {
  font-size: 14px;
  font-weight: bold;
}
.input-link {
  position: absolute;
  cursor: pointer;
  right: 16px;
  margin-top: 15px;
}
.verify-alert {
  p {
    margin: 0;
  }
}
</style>
